<div class="flex-column full-width">

    <h6 
        class="mat-headline-6 margin-none border-gray-bottom padding-standard"
    >
        {{'ss-process-wizard.actor.auth-config-title' | translate}}
    </h6>

    <div class="flex-column gap-small padding-standard">

        <ss-actor-auth *ngFor="let actorAuthDef of actorAuthDefs;" [actorAuthDef]="actorAuthDef"></ss-actor-auth>

    </div>
    
</div>